<template>
  <div class="real-container">
    <v-row class="ui-row">
      <v-col
        cols="12"
        md="12"
        class="d-flex flex-row"
      >
        <h2 class="content-tit">
            {{pageTitle}}
        </h2>
        <div class="data-control">
          <button type="button" class="button search-btn" @click="searchBackOrderInfo()">
            <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px" fill="#ffffff"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/></svg>
            검색
          </button>
          <button type="button" class="button data-excel" @click="exportExcel()">
            <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px" fill="#fff"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/><path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/></svg>
            엑셀다운
          </button>
        </div>
      </v-col>
      <v-col
        cols="12"
        md="6"
        lg="4"
        class="ui-col client-ui"
      >
      <label class="default-tit input-tit text-center" for="client-tit">
          거래처 
        </label>
        <div class="client-box">
          <input type="text"
            class="default-input client-input left"
            @click="clientFlag = true"
            id="client-tit"
            v-model="strCustCd"
            :disabled="custList.length <= 1"
          />
          <button type="button"
            @click="clientFlag = true"
            v-if="custList.length > 1"
            class="client-search-btn">
            <svg xmlns="http://www.w3.org/2000/svg" class="search-icon" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000">
              <path d="M0 0h24v24H0z" fill="none"/>
              <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
            </svg>
          </button>
          <input type="text" class="default-input client-input right" id="client-right" v-model="strCustNm" disabled/>
        </div>
      </v-col>
      <v-col
        cols="12"
        md="6"
        lg="4"
        class="ui-col"
      >
      <label class="default-tit input-tit text-center" for="occurrence-start">
          등록일 
        </label>
        <div class="date-container half">
          <div class="datepicker-aligns">
            <v-menu
              v-model="dateFromMain"
              :close-on-content-click="false"
              :nudge-left="0"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="occurrenceFromMain"
                  prepend-icon="mdi-calendar"      
                  label="From"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="occurrenceFromMain"
                locale="ko"
                @input="dateFromMain = false"
              ></v-date-picker>
            </v-menu>
          </div>
        </div>
        <div class="date-container half">
          <div class="datepicker-aligns">
            <v-menu
              v-model="dateToMain"
              :close-on-content-click="false"
              :nudge-left="0"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="occurrenceToMain"
                  prepend-icon="mdi-calendar"      
                  label="To"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="occurrenceToMain"
                locale="ko"
                @input="dateToMain = false"
              ></v-date-picker>
            </v-menu>
          </div>
        </div>
      </v-col>
      <!-- <v-col
        cols="12"
        md="6"
        lg="4"
        class="ui-col"
      >
      <label class="default-tit input-tit text-center" for="useryn-val">
          사용여부
        </label>
        <multiselect
          id="useryn-val"
          v-model="userYnVal"
          :options="userYn"
          :multiple="false"
          selectLabel="추가"
          deselectLabel="선택중"
          placeholder="사용여부를 선택해주세요."
          class="default-v-select text-ellip"
          track-by="name"
          :searchable="true"
          :allow-empty="false"
          label="name"><span slot="noResult">사용여부를 선택해주세요.</span></multiselect>
      </v-col>
      <v-col
        cols="12"
        md="6"
        lg="4"
        class="ui-col"
      >
      <label class="default-tit input-tit text-center" for="ordcrey-val">
          생성여부
        </label>
        <multiselect
          id="useryn-val"
          v-model="ordCreynVal"
          :options="ordCreyn"
          :multiple="false"
          selectLabel="추가"
          deselectLabel="선택중"
          placeholder="생성여부를 선택해주세요."
          class="default-v-select text-ellip"
          track-by="name"
          :searchable="true"
          :allow-empty="false"
          label="name"><span slot="noResult">생성여부를 선택해주세요.</span></multiselect>
      </v-col> -->
    </v-row>
    <v-row class="ui-row">
      <v-col
        cols="12"
        md="12"
        class="ui-col d-flex flex-column"
      >
          <h3 class="grid-tit">{{cardTitle}}</h3>
          <!--<div id="master-left-data" class="real-grid"></div>-->
          <div id="master-grid" class="real-grid"></div>
      </v-col>
    </v-row>
    <div data-app>
    <v-dialog
      v-model="clientFlag"
      persistent
      max-width="800px"
      id="user-info-modal"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{clientPopTitle}}</span>
        </v-card-title>
        <v-card-text class="regist-container">
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="12"
                class="client-col regist-col"
              >
                <CustPopup ref="custPopRef" v-if="clientFlag" @selectCustEvent="selectCustPop"></CustPopup>
              </v-col>
              <v-col
                cols="12"
                md="12"
                class="regist-col last justify-end"
              >
                <v-btn
                  color="blue darken-1"
                  text
                  @click="custInit()"
                >
                  초기화
                </v-btn>
                <v-btn
                  class="default-btn-style"
                  color="blue darken-1"
                  text
                  @click="clientFlag = false"
                >
                  닫기
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    </div>
  </div>
</template>
<script>
import JSZip from 'jszip'
import CustPopup from '@/components/CustPopup.vue'
import { GridView, LocalDataProvider } from 'realgrid'
import { backOrderfields, backOrderColumns } from './gridData/BackOrderSearch.js'
import { mapGetters } from 'vuex'
let mstGridView = GridView
let mstDataProvider = LocalDataProvider


export default {
  name: 'BackOrderSearch',
  components: {
    CustPopup
  },  
  data() {
    return {
      pageTitle:'백오더 조회',
      cardTitle: 'Back Order 내역',
      clientFlag: false,
      dateToMain: false,
      occurrenceToMain: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      dateFromMain: false,
      occurrenceFromMain: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      clientPopFlag: false,
      clientPopTitle: '거래처 선택',
      curDate: '',
      custInsList: [],
      custList: [],
      strCustCd: '',
      strCustNm: '',
      deptList: [],
      strDeptCd: '',
      strDeptNm: '',
      mstListData: [
      ],
      ownerKey: '',
      userId: '',
      strAgentCd: '',
      locationVal: '',
      processingVal: '',
      deliveryVal: '',
      userYn: [
        {name: '전체', value: ''},
        {name: '네', value: 'Y'},
        {name: '아니오', value: 'N'}
      ],
      userYnVal:'',
      ordCreyn: [
        {name: '전체', value: ''},
        {name: '네', value: 'Y'},
        {name: '아니오', value: 'N'}
      ],
      ordCreynVal: ''
    }
  },
  created() {
    // console.log('------- cust ---------')
    let info = JSON.parse(sessionStorage.getItem('userInfo'))
    var selectOwner = sessionStorage.getItem('selectOwner')

    this.ownerKey = selectOwner
    this.userId = info[0].userId
    

    if(this.codeInfoObj === '' || this.codeInfoObj === null){
      setTimeout(() => {
        this.initSettings()
        this.$loadingHide()
      }, 1000)
    }else{
      this.initSettings()
    }
  },
  methods: {
    initSettings(){
      this.custList = []
      for(var i=0; i<this.custInfoObj.length; i++){
        var item = {'custCd' : this.custInfoObj[i].custCd, 'custNm' : this.custInfoObj[i].custNm, 'agentCd' : this.custInfoObj[i].agentCd }
        if(this.custList.findIndex((items) => items.custCd == this.custInfoObj[i].custCd) === -1){
          this.custList.push(item)
        }
      }

      if(this.custList.length === 1){
        this.strCustCd = this.custList[0].custCd
        this.strCustNm = this.custList[0].custNm
        this.strAgentCd = this.custList[0].agentcd
      }
      // console.log(this.custList)
    },
    selectCustPop(popData){
      this.strCustCd = popData.custCd
      this.strCustNm = popData.custNm
      this.clientFlag = false
      this.deptList = []
      for(var i=0; i<this.custInfoObj.length; i++){
        var item = this.custInfoObj[i]

        if(item.custCd === this.strCustCd){
          this.deptList.push(item)
        }
      }
      if(this.deptList.length === 1){
        this.strDeptCd = this.deptList[0].deptCd
        this.strDeptNm = this.deptList[0].deptNm
      }
    },
    custInit(){
      this.strCustCd = ''
      this.strCustNm = ''
      this.strDeptCd = ''
      this.strDeptNm = ''
      this.clientFlag = false
    },
    searchBackOrderInfo() {
      let fromYmd = this.occurrenceFromMain.replace(/-/g, '')
      let toYmd = this.occurrenceToMain.replace(/-/g, '')

      if(this.strCustCd === ''){
        // alert('거래처를 선택해 주세요.')
        this.$swal({
            title: '거래처를 선택해 주세요.'
        })
        return
      }
      this.$loading.show({delay:0})
      this.$store.dispatch('apiBackOrderInfo', {'ownerKey': this.ownerKey, 'userYn': 'Y', 'ordCreyn': 'N', 'fromDt':fromYmd, 'toDt':toYmd, 'custCd': this.strCustCd}).then(() => {       
        // 사용여부, 생성여부 하드코딩 처리
        if(this.backOrdInfoObj.code === 'OK') { 
            this.mstListData = []
            this.mstListData = this.backOrdInfoObj.backInfo
            mstDataProvider.setRows(this.mstListData)
        } else {
          //alert(this.backOrdInfoObj.message)
          this.$swal({
            title: this.backOrdInfoObj.message
          })
          mstDataProvider.clearRows()
        }
      }).catch((error) => {
        // alert('ErrorCode = ' + error.response.status + ' / ' + error.message + '\n시스템에 이상이 있습니다. 다시 시도해 주세요.')
        this.$swal({
            title: 'ErrorCode = ' + error.response.status + ' / ' + error.message + '\n시스템에 이상이 있습니다. 다시 시도해 주세요.'
        })
      }).finally(() => {
        setTimeout(() => {
          this.$loadingHide()
        }, 300)
      })
    },
    exportExcel(){
      if(this.strCustCd === ''){
        // alert('거래처를 선택해 주세요.')
        this.$swal({
            title: '거래처를 선택해 주세요.'
        })
        return
      }
      let downFromYmd = this.occurrenceFromMain.replace(/-/g, '')
      let downToYmd = this.occurrenceToMain.replace(/-/g, '')
      this.$loading.show({delay:0})
      this.$store.dispatch('apiFileLog', {'fileName': 'BackOrder.xlsx', 'fileType': 'EXCEL', 'custCd': this.strCustCd, 'fromDt':downFromYmd, 'toDt':downToYmd }).then(() => {       
          mstGridView.exportGrid({
            type: "excel",
            target: "local",
            fileName: "BackOrder.xlsx",
            showProgress: true,
            progressMessage: "엑셀 Export중입니다.",
            indicator: 'hidden',
            header: true,
            compatibility: '2010',
            linear: true,
            separateRows: true,
            allColumns:true,
            //hideColumns: ["deptCd", "pick_zone", "pick_seq"],
            lookupDisplay:true
        })
      }).catch((error) => {
        // alert('ErrorCode = ' + error.response.status + ' / ' + error.message + '\n시스템에 이상이 있습니다. 다시 시도해 주세요.')
        this.$swal({
            title: 'ErrorCode = ' + error.response.status + ' / ' + error.message + '\n시스템에 이상이 있습니다. 다시 시도해 주세요.'
        })
      }).finally(() => {
        setTimeout(() => {
          this.$loadingHide()
        }, 300)
      })

    }   
  },
  mounted() {
    
    //console.log('------------ 기초정보 --------')
    // console.log(this.codeInfoObj)
    //console.log(this.custInfoObj)
    // console.log(this.ordCustCodeObj)

    // this.locationVal = this.locationOption[0]
    // this.processingVal = this.processingOption[0]
    // this.deliveryVal = this.deliveryOption[0]

    window.JSZip = window.JSZip || JSZip

    mstDataProvider = new LocalDataProvider(true)
    mstGridView = new GridView('master-grid')
    mstGridView.setDataSource(mstDataProvider)
    mstGridView.setCheckBar({
      visible: false
    })
    mstGridView.setStateBar({
      visible: false
    })
    mstGridView.setPasteOptions({
      enabled: false
    })
    mstGridView.setEditOptions({
      editable: false,
      updatable: false
    }),
    mstDataProvider.setFields(backOrderfields)
    mstGridView.setColumns(backOrderColumns)
    //mstGridView.setCheckableExpression("(values['print_yn'] = 'Y') AND (values['status'] = 'Y')", true);
    
    //mstGridView.setColumnProperty("cust_nm", "autoFilter", true)
    mstGridView.displayOptions.selectionStyle = "singleRow"
    mstGridView.displayOptions.fitStyle = "even"
    this.userYnVal = this.userYn[0]
    this.ordCreynVal = this.ordCreyn[0]
  },
  computed: {
    ...mapGetters({
      codeInfoObj: 'getCodeData',
      custInfoObj: 'getCustMstData',
      backOrdInfoObj: 'getBackOrdInfo'
    })
  }
}
</script>
